import { createSlice } from "@reduxjs/toolkit";
import { LIVE_TRACKER } from "../../../constants/reducer_names";



const initialState: any = {
    liveTrackerList: []
} as any;

const liveTrackerSlice = createSlice({
    name: LIVE_TRACKER,
    initialState,
    reducers: {
        setLiveTrackerList: (state, { payload }) => {
            try {
                const sessionId = payload?.sesionId;
                const status = payload?.status;
                if (!sessionId) return;
                if (status === 'closed') {
                    state.liveTrackerList = [...state.liveTrackerList].filter(
                        (item: any) => {
                            return item?.sesionId !== sessionId
                        }
                    );
                } else {
                    const index = state.liveTrackerList.findIndex(
                        (item: any) => item?.sesionId === sessionId
                    );
                    if (index !== -1) {
                        state.liveTrackerList[index] = payload;
                    } else {
                        state.liveTrackerList.push(payload);
                    }
                }
            } catch (error) {
                console.log('liveTrackerList',error)
            }
        },
        reset: (state) => {
            state.liveTrackerList = []
        }
    }
});


export const LiveTrackerActions = liveTrackerSlice.actions;
export default liveTrackerSlice.reducer;



